import { Collapse, Flex } from "antd";
import Title from "antd/es/typography/Title";
import { QUESTIONS } from "../../../constants/AppConstants";

import "./Questions.css";

export default function Questions() {
  return (
    <>
      <Flex className="questions-section-container my-80" id="preguntas">
        <Title className="questions-section-title" strong>
          {QUESTIONS.TITLE}
        </Title>
      </Flex>
      <Flex className="questions-container">
        <Collapse className="questions-collapse" items={QUESTIONS.LIST} />
      </Flex>
    </>
  );
}
